import { writable } from 'svelte/store'

let protocolObj = {
  eu_name: '',
  _id: null,
  machine_id: null,
  machine_model: '',
  machine_no: null,
  measurements: [],
  modified: '',
  project_id: null,
  status: 0,
  su_rp_proj: '',
  username: null,
  hours_upgraded: 0,
  what_upgraded: [],
  chain: ''
}

let parameterObj = {
  name: '',
  platform: '',
  limits: [
    { name: '1.', value: 0 },
    { name: '2.', value: 0 },
    { name: '3.', value: 0 },
  ],
  func: ''
}

export let protocol = writable(protocolObj)

export let parameter = writable(parameterObj)
